@if (vm$ | async; as vm) {
  <div class="guts-m-b-5">
    <div class="grid__col-12">
      <div class="l_flexbar m-l_flexbar-col">
        <!-- Search -->
        <dgx-data-search
          [placeholder]="i18n.dgManagePathways_SearchPlaceholder"
          [searchTerm]="vm.term"
          type="short"
          class="m-full-width m-guts-m-b-1"
          (doSearch)="vm.search($event)"
        ></dgx-data-search>
        <dgx-data-filters
          [filters]="vm.filters"
          (filtersChange)="vm.updateFilters($event.filters)"
          class="guts-m-l-1 m-full-width m-guts-m-l-0"
        >
        </dgx-data-filters>
        <!-- actions, from right to left -->
        <div class="l_flex--align-right m-guts-p-full-0 m-guts-m-full-0">
          @if (enableCreatePlan) {
            <button
              type="button"
              class="tw-btn-primary tw-btn-medium"
              (click)="showAddModal()"
              data-dgat="orgPages-cc0"
            >
              <da-icon
                icon="plus"
                type="solid-small"
                class="tw-reset tw-inline-block tw-align-middle"
              ></da-icon>
              {{ 'OrgPlans_CreateTargetOrDirectory' | translate }}
            </button>
          }
        </div>
      </div>
    </div>
    <dgx-data-table
      id="org-plans-table"
      [canSelect]="canUpdatePlans || canDeletePlans"
      [canSort]="true"
      [columns]="columns"
      [isLoading]="vm.showSkeleton || vm.isLoading"
      [isSorting]="vm.isSorting"
      [hasNoResults]="vm.paging.totalCount === 0"
      [isDescending]="vm.ordering.isDescending"
      [items]="vm.allPlans"
      [readOnlyItems]="true"
      [menuSettings]="actions"
      [orderBy]="vm.ordering.orderBy"
      propTrackingKey="targetId"
      (updateSort)="vm.updateSort($event)"
      (select)="selectPlan($event)"
      (bulkSelect)="bulkSelect($event)"
      [perPageOptions]="[
        { value: 10, display: '10' },
        { value: 30, display: '30' },
        { value: 50, display: '50' },
      ]"
      [numResultsPerPage]="vm.paging.take"
      (pageChange)="vm.changePage($event)"
      (perPageChange)="vm.changePageSize($event)"
      [pageNum]="vm.paging.page"
      [totalNumResults]="vm.paging.totalCount"
      [showPerPage]="true"
      [useSkeleton]="true"
    ></dgx-data-table>
    <div class="grid__col-12 tw-h-70 tw-py-0">
      <dgx-data-bulk-actions
        class="full-width m-guts-m-h-1"
        [numItemsForAction]="$safeNavigationMigration(vm.selectedPlans?.length)"
        (bulkActionsCancelled)="clearSelections()"
        bulkEditContainer="org-plans-table"
        [bulkActionsEnabled]="
          $safeNavigationMigration(vm.selectedPlans?.length) > 0
        "
      >
        @if (canUpdatePlans && !hideLegacyAccessActions) {
          <!-- add collaborators -->
          <dgx-data-bulk-action-button
            actionIcon="user-group"
            dgatInput="bulkActions-adf"
            [displayText]="'OrgPathwayManagerCtrl_AddCollaborators' | translate"
            (buttonAction)="showBulkCollaboratorsModal()"
          ></dgx-data-bulk-action-button>
        }
        @if (canUpdatePlans && canAddOrgPlans && !hideLegacyAccessActions) {
          <!-- visibility -->
          <dgx-data-bulk-action-button
            actionIcon="eye"
            dgatInput="bulkActions-adf"
            [displayText]="'OrgPathwayManagerCtrl_UpdateVisibility' | translate"
            (buttonAction)="showBulkVisibilityModal()"
          ></dgx-data-bulk-action-button>
        }
        <!-- delete -->
        @if (canDeletePlans) {
          <dgx-data-bulk-action-button
            actionIcon="trash"
            [displayText]="'OrgPathwayManagerCtrl_Delete' | translate"
            [disabled]="!vm.canBulkDeleteSelected"
            [ariaDescribedby]="
              vm.canBulkDeleteSelected ? null : bulkDeleteBlockedHelpId
            "
            (buttonAction)="showBulkDeleteModal()"
            dgatInput="bulkActions-adf"
          ></dgx-data-bulk-action-button>
          <!-- Say WHY Delete is unavailable; aria-disabled alone gives no reason. -->
          @if (!vm.canBulkDeleteSelected) {
            <p [id]="bulkDeleteBlockedHelpId" class="par par--small par--light">
              {{ bulkDeleteBlockedHelpText }}
            </p>
          }
        }
      </dgx-data-bulk-actions>
    </div>
    <dgx-footer-glasses></dgx-footer-glasses>
  </div>
}

<ng-template #titleColumn let-item>
  <dgx-plan-link [plan]="item" [autoPopulate]="false"></dgx-plan-link>
</ng-template>
<ng-template #subtitleColumn let-item>
  {{ item.subtitle }}
</ng-template>
<ng-template #targetTypeColumn let-item>
  {{ item.displayTargetType }}</ng-template
>
<ng-template #visibilityColumn let-item>
  {{ 'OrgPathwayManagerCtrl_Visibility' + item.privacyId | translate }}
</ng-template>
<ng-template #followersColumn let-item>
  {{ item.followerCount }}
</ng-template>
<ng-template #authorsColumn let-item>
  <dgx-authors-list [authored]="item.authored"></dgx-authors-list>
</ng-template>
